/**
 * KPI Category Configuration
 *
 * Industrial-themed visual configuration (colors, icons, labels) for the
 * 5 KPI categories. Used by the KPI Library card grid + AI Builder preview.
 *
 * Phase 24.7 (Track 1): extracted from `pages/settings/KpiSettingsPage.tsx`
 * before that page was deleted in PR 3 (Chunk 7). Follows the precedent of
 * `lib/score-colors.ts` (Phase 16 lookup-constant extraction).
 */

import {
  Activity,
  Timer,
  ClipboardCheck,
  HardHat,
  TrendingUp,
  Gauge,
} from 'lucide-react';
import type { KpiCategory } from '@guild/shared';

export const categoryConfig: Record<KpiCategory, {
  label: string;
  bg: string;
  text: string;
  border: string;
  icon: typeof Activity;
  gradient: string;
}> = {
  safety: {
    label: 'Safety',
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
    icon: HardHat,
    gradient: 'from-red-500 to-rose-600',
  },
  efficiency: {
    label: 'Efficiency',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'border-blue-200',
    icon: Timer,
    gradient: 'from-blue-500 to-cyan-600',
  },
  compliance: {
    label: 'Compliance',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    border: 'border-purple-200',
    icon: ClipboardCheck,
    gradient: 'from-purple-500 to-violet-600',
  },
  productivity: {
    label: 'Productivity',
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    icon: TrendingUp,
    gradient: 'from-emerald-500 to-teal-600',
  },
  quality: {
    label: 'Quality',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
    icon: Gauge,
    gradient: 'from-amber-500 to-orange-600',
  },
};
